module.exports = __webpack_public_path__ + "img/ykfy.4bb046b4.jpg";